import React from 'react'
import { Card, CardContent, Typography } from '@material-ui/core'
import FormWrapperCheckButton from './FormWrapperCheckButton'

interface IGroupHeaderCardProps {
  groupLabel: string
  disableTabs: boolean
  incompleteFields: boolean
  tabLightClass: string
}

/**
 * Memoized component to prevent Card from flickering on every state update.
 * Only re-renders when its specific props change.
 *
 * NOTE: Intentionally ignores `disableTabs` to prevent flicker during save/state operations.
 * The Card remains mounted but uses CSS to hide/show smoothly.
 */
/* eslint-disable react/prop-types */
export const GroupHeaderCard = React.memo<IGroupHeaderCardProps>(
  ({ groupLabel, disableTabs, incompleteFields, tabLightClass }) => {
    return (
      <Card
        className={tabLightClass}
        style={{
          display: !disableTabs ? 'block' : 'none'
        }}
      >
        <CardContent
          style={{
            background: 'inherit !important'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography>{groupLabel}</Typography>
            {!incompleteFields && <FormWrapperCheckButton />}
          </div>
        </CardContent>
      </Card>
    )
  },
  (prevProps, nextProps) => {
    // Return true if props are equal (prevent re-render)
    // Return false if props are different (allow re-render)
    // NOTE: Intentionally ignoring disableTabs to prevent flicker during rapid toggles
    const isEqual =
      prevProps.groupLabel === nextProps.groupLabel &&
      prevProps.incompleteFields === nextProps.incompleteFields &&
      prevProps.tabLightClass === nextProps.tabLightClass

    console.log(isEqual, 'isEqual')

    return isEqual
  }
)
/* eslint-enable react/prop-types */

GroupHeaderCard.displayName = 'GroupHeaderCard'
